import React, { createContext, useState, useCallback } from "react";

export const GuideContext = createContext({
  guideMode: false,
  toggleGuideMode: () => {},
  setGuideMode: () => {},
  tourRequest: 0,
  requestTour: () => {},
  previewTour: null,
  requestTourPreview: () => {},
  clearTourPreview: () => {},
});

export const GuideProvider = ({ children }) => {
  // guideMode reveals the inline info hotspots (InfoModal) across pages.
  const [guideMode, setGuideMode] = useState(false);
  // Incremented whenever someone asks for the current page's tour to (re)start.
  const [tourRequest, setTourRequest] = useState(0);
  // Optional draft tour provided by the authoring workbench for live preview.
  const [previewTour, setPreviewTour] = useState(null);

  const toggleGuideMode = useCallback(() => {
    setGuideMode((prev) => !prev);
  }, []);

  const requestTour = useCallback(() => {
    setTourRequest((prev) => prev + 1);
  }, []);

  const requestTourPreview = useCallback((draft) => {
    setPreviewTour(draft);
    setTourRequest((prev) => prev + 1);
  }, []);

  const clearTourPreview = useCallback(() => {
    setPreviewTour(null);
  }, []);

  return (
    <GuideContext.Provider
      value={{
        guideMode,
        toggleGuideMode,
        setGuideMode,
        tourRequest,
        requestTour,
        previewTour,
        requestTourPreview,
        clearTourPreview,
      }}
    >
      {children}
    </GuideContext.Provider>
  );
};
